// External packages
import * as React from 'react';
import { z } from 'zod';

// Components
import { Form, InputField } from 'components/Form';
import { Button } from 'components/Button';
import * as Modal from 'components/Modal';

// Hooks
import { useCreateLicense } from 'api/license';

const createLicenseSchema = z.object({
  uuid: z.string().optional(),
  validUntil: z.string().optional(),
});

type CreateLicenseModalProps = {
  modalTrigger?: React.ReactNode;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export const CreateLicenseModal: React.FC<CreateLicenseModalProps> = ({
  modalTrigger,
  isOpen,
  onOpenChange,
}) => {
  const { mutate: createLicense, isPending } = useCreateLicense();

  const handleSubmit = (data: z.infer<typeof createLicenseSchema>) => {
    createLicense(
      { data },
      {
        onSuccess: () => {
          onOpenChange?.(false);
        },
      }
    );
  };

  return (
    <Modal.TriggerRoot isOpen={isOpen} onOpenChange={onOpenChange}>
      {modalTrigger}
      <Modal.Overlay isDismissable>
        <Modal.Root>
          <Modal.Dialog>
            <Modal.Close />
            <h3 className="mb-8 text-2xl text-gray-600">Dodaj ulaznicu</h3>
            <Form schema={createLicenseSchema} onSubmit={handleSubmit}>
              <InputField
                name="uuid"
                inputProps={{ colorScheme: 'white' }}
                label="Customer UUID (opcionalno)"
                className="flex-1"
              />
              <p className="mb-4 text-xs text-gray-500">
                Ostavite prazno za MANUAL aktivaciju, unesite UUID za APP
                aktivaciju
              </p>
              <InputField
                name="validUntil"
                inputProps={{
                  colorScheme: 'white',
                  type: 'date',
                }}
                label="Vrijedi do (opcionalno)"
                className="flex-1 mb-4"
              />
              <Button
                type="submit"
                className="w-full mt-12"
                size="lg"
                isPending={isPending}
              >
                Stvori ulaznicu
              </Button>
            </Form>
          </Modal.Dialog>
        </Modal.Root>
      </Modal.Overlay>
    </Modal.TriggerRoot>
  );
};
